import { render } from "./MediaCards.vue?vue&type=template&id=d9ec807c&ts=true"
import script from "./MediaCards.vue?vue&type=script&lang=ts"
export * from "./MediaCards.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src835202786/src/web-previewer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__